import { createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../../services/apiClient';
import { toast } from 'react-toastify';

export const fetchRoles = createAsyncThunk(
  'roles/fetchRoles',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiClient.get('/api/v1/roles-management/roles'); 
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchPermissions = createAsyncThunk(
  'roles/fetchPermissions',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiClient.get('/api/v1/roles-management/permissions');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateRolePermissions = createAsyncThunk(
  'roles/updateRolePermissions',
  async ({ roleId, permissionIds }, { rejectWithValue }) => {
    try {
      const response = await apiClient.put(
        `/api/v1/roles-management/roles/${roleId}/permissions`,
        { permissionIds: permissionIds }
      );
      toast.success('Permissions mises à jour avec succès !');
      return response.data;
    } catch (error) {
      toast.error(error.response?.data?.message || 'Erreur lors de la mise à jour des permissions.');
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createRole = createAsyncThunk(
  'roles/createRole',
  async (roleName, { rejectWithValue }) => {
    try {
      const response = await apiClient.post('/api/v1/roles-management/roles', { name: roleName });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);